import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import Utils from "../../../utils/Utils";
import Loader from "../../../components/Loader";
import WebUtils from "../../../utils/WebUtils";
import { getModuleAccessInfoApi } from "../../../api/candidate";
import { ROLES } from "../../../constants/UserRoles";
import ViewReportMain from "../../../components/b2bCandidate/cvOptimizer/viewReport/ViewReportMain";
import { getResumeJdMatchDataApi } from "../../../api/b2b-candidate";
import { useSearchParams } from "react-router-dom";

function ViewReport() {
  const [searchParams] = useSearchParams();

  const matchAnalysisIdentifier = searchParams.get("matchAnalysisIdentifier");

  const resumeIdentifier = searchParams.get("resumeIdentifier");
  const userDetail = Utils.getUserDetail();

  const [loading, setLoading] = useState(false);
  const [matchData, setMatchData] = useState(null);

  const getResumeJdMatchData = async () => {
    const url = `${getResumeJdMatchDataApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&matchAnalysisIdentifier=${matchAnalysisIdentifier}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setMatchData(result.data?.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getResumeJdMatchData();
  }, []);

  return (
    <>
      {loading && <Loader />}
      <div className="hirePlusPlusPageContent">
        <Sidebar
          collapseSidbar="left"
          activePage="cv-optimizer"
          userRole={
            userDetail?.userRole === "JOBDRONA_CANDIDATE"
              ? "candidate"
              : ROLES.b2b_candidate
          }
        />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="cv-optimizer"
            userRole={
              userDetail?.userRole === "JOBDRONA_CANDIDATE"
                ? "candidate"
                : ROLES.b2b_candidate
            }
            newTitle="View Report"
            noNavigate={false}
          />
          <div className="">
            {matchData?.analysisResult ? (
              <ViewReportMain
                matchData={matchData}
                setLoading={setLoading}
                userDetail={userDetail}
              />
            ) : (
              <div className="mt-12 mb-2 text-gray-500 text-center">
                No matching data found.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewReport;
